import { FunctionComponent, RefObject, useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'

import AddressSearchInput from 'modules/AddressAutocomplete'

import Container from 'components/GlobalStyles/Marketing/Container'
import Spacer from 'components/Spacer'

const StyledGlobalContainer = styled(Container)`
  @media (min-width: ${props => props.theme.metrics.desktopLarge}px) {
    padding: 0 28px 0 168px;
    max-width: 1440px;
  }
`

const GradientContainer = styled.div`
  background: linear-gradient(96.85deg, #07bff1 19.97%, #1299ec 82.65%);
  color: ${props => props.theme.colors.white};
  width: 100%;
`

const LayoutContainer = styled.div`
  @media (min-width: ${props => props.theme.metrics.desktop}px) {
    display: flex;
    flex-direction: row;
  }
`

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  @media (min-width: ${props => props.theme.metrics.desktop}px) {
    max-width: 56%;
  }
  @media (min-width: ${props => props.theme.metrics.desktopLarge}px) {
    max-width: 60%;
  }
`

const Header = styled.div`
  font-size: 36px;
  font-weight: 800;
  line-height: 45px;
  @media (min-width: ${props => props.theme.metrics.desktop}px) {
    font-size: 40px;
    line-height: 55px;
  }
`

const Text = styled.div`
  font-size: ${props => props.theme.fonts.sizes[16]}px;
  font-weight: 500;
  line-height: 22px;
`

const ImageContainer = styled.div`
  transform: none;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: -100px;
  @media (min-width: ${props => props.theme.metrics.desktop}px) {
    width: 40%;
    transform: scale(0.4) translate(32px, -620px);
    right: 0;
    margin: 0;
  }
  @media (min-width: ${props => props.theme.metrics.desktopLarge}px) {
    transform: scale(0.4) translate(56px, -620px);
  }
`

const NestedImageContainer = styled.div`
  position: relative;
  @media (min-width: ${props => props.theme.metrics.desktop}px) {
    height: unset;
    position: absolute;
  }
`

const Image = styled.img`
  height: 320px;
  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    height: 540px;
  }
  @media (min-width: ${props => props.theme.metrics.desktop}px) {
    height: unset;
  }
`
interface IProps {
  getStartedRef?:
    | ((instance: HTMLDivElement | null) => void)
    | RefObject<HTMLDivElement>
    | null
    | undefined
}
const SignUpA: FunctionComponent<IProps> = ({ getStartedRef }) => {
  const theme = useContext(ThemeContext)
  return (
    <GradientContainer ref={getStartedRef}>
      <Spacer
        size={72}
        tabletSize={50}
        responsiveSize={32}
      />
      <StyledGlobalContainer>
        <LayoutContainer>
          <ContentContainer>
            <Header>Get started for free today.</Header>
            <Spacer
              size={24}
              desktopSize={32}
            />
            <Text>
              Enter your property address to see how much more of your equity you can keep. Savings
              await...
            </Text>
            <Spacer
              size={50}
              tabletSize={40}
              responsiveSize={30}
            />
            <AddressSearchInput
              buttonBackground={theme.colors.yellow4}
              buttonBackgroundHover={theme.colors.yellow2}
              buttonFontSize={12}
              inputBackground={theme.colors.transparentGrey30Alpha50}
              buttonWidth={200}
              dropShadow="0px 24px 48px rgba(112, 112, 112, 0.32)"
            />
          </ContentContainer>
          <ImageContainer>
            <NestedImageContainer>
              <Image
                src={`${process.env.CDN_BASE_URL}/q_auto,w_1280/amazon/assets/yard-sign-transparent-2.png`}
                alt="HomeLister Yard Sign"
              />
            </NestedImageContainer>
          </ImageContainer>
        </LayoutContainer>
      </StyledGlobalContainer>
      <Spacer
        size={72}
        tabletSize={50}
        responsiveSize={32}
      />
    </GradientContainer>
  )
}

export default SignUpA
